import * as React from 'react';
import { SVGProps } from 'react';
const SvgIcZoomOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 9.75C3 6.02 6.02 3 9.75 3s6.75 3.02 6.75 6.75-3.02 6.75-6.75 6.75S3 13.48 3 9.75Zm12 0a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 1 0 10.5 0Zm.53 5.47 5.25 5.25-1.06 1.06-5.25-5.25 1.06-1.06ZM13.46 9H6.04v1.5h7.42V9Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M3 3h17.78v18.53H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgIcZoomOut;
